import type { AgeVerificationMethodType } from "@jti/fe-common";

import { VERIFF_AGE_ESTIMATION, VERIFF_AV } from "../../constants";

export type AgeEstimationResult = "pending" | "passed" | "fallback" | "failed";

type ResolveAgeEstimationResultInput = {
  availableMethods: AgeVerificationMethodType[];
  isVerified: boolean;
  methodCode: string;
  verificationPerformed: boolean;
};

export const isAgeEstimationMethod = (methodCode: string): boolean => methodCode === VERIFF_AGE_ESTIMATION;

export const getAgeEstimationFallbackMethod = (
  methods: AgeVerificationMethodType[]
): AgeVerificationMethodType | undefined => methods.find(({ code }) => code === VERIFF_AV);

export const getAgeEstimationVisibleMethods = (
  methods: AgeVerificationMethodType[],
  authorizedMethodCode: string
): AgeVerificationMethodType[] => {
  const ageEstimationMethod = methods.find(({ code }) => isAgeEstimationMethod(code));

  if (!ageEstimationMethod) {
    return methods;
  }

  const fallbackMethod = getAgeEstimationFallbackMethod(methods);
  if (authorizedMethodCode === VERIFF_AV && fallbackMethod) {
    return [fallbackMethod];
  }

  return [ageEstimationMethod];
};

export const resolveAgeEstimationResult = ({
  availableMethods,
  isVerified,
  methodCode,
  verificationPerformed,
}: ResolveAgeEstimationResultInput): AgeEstimationResult | null => {
  if (!isAgeEstimationMethod(methodCode)) {
    return null;
  }

  if (!verificationPerformed) {
    return "pending";
  }

  if (isVerified) {
    return "passed";
  }

  return getAgeEstimationFallbackMethod(availableMethods) ? "fallback" : "failed";
};
